// extracted by mini-css-extract-plugin
module.exports = {"Container":"CitiesList_Container__2vQK6","Header":"CitiesList_Header__f3DOE","List":"CitiesList_List__qQgqP"};